import { Subject } from 'rxjs';

const subject = new Subject();

export const deleteCommentService = {
  emitReload: val => subject.next(val),
  reload: () => subject.asObservable()
};